import { SaleMessageConfigResponse, SaleMessageListResponse, } from '@aeris/contracts';
import { request } from "./client.js";
const base = '/api/v1/communication/sale-messages';
export const fetchSaleMessageConfig = async (signal) => SaleMessageConfigResponse.parse(await request(`${base}/config`, { signal }));
export const saveSaleMessageConfig = async (body) => SaleMessageConfigResponse.parse(await request(`${base}/config`, { method: 'PUT', body }));
/** As mensagens de um dia (`YYYY-MM-DD`, horário de Brasília). */
export const fetchSaleMessages = async (date, signal) => SaleMessageListResponse.parse(await request(`${base}?date=${encodeURIComponent(date)}`, { signal })).entries;
export const cancelSaleMessage = async (id) => {
    await request(`${base}/${id}/cancel`, { method: 'POST' });
};
export const sendSaleMessageNow = async (id) => {
    await request(`${base}/${id}/send-now`, { method: 'POST' });
};
//# sourceMappingURL=sale-messages.js.map